import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Communication Type

 
  GetAllCommunicationType(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllCommunicationType', formData);
  }

  SaveCommunicationType(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveCommunicationType', formData);
  }

  CommunicationTypeMarkActive(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/CommunicationTypeMarkActive', formData);
  }

  // Communication

  GetStudentDetails(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objFilter", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetStudentForCommunication', formData);
  }

  GetStaffDetails(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objFilter", objModel); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetStaffforCommunication', formData);
  }

  SaveCommunication(list, data,file): Observable<any> {
    let formData = new FormData();
    formData.append("objList", list); 
    formData.append("objModel", data); 
    for (var i = 0; i < file.length; i++) {
      formData.append("AlbumPhoto" + i, file[i]);
    }
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveCommunication', formData);
  }

  GetAllCommunication(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllCommunication', formData);
  }


   // Communication Document

   SaveCommDocument(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveCommDocument', formData);
  }

  
  GetAllCommDocument(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllCommDocument', formData);
  }

  DocumentMarkActive(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/DocumentMarkActive', formData);
  }

    // Document Uploading

    GetAllDocumentsUploading(objModel): Observable<any> {
      let formData = new FormData();
      formData.append("objModel", objModel);    
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllDocumentsUploading', formData);
    }

    SaveDocumentsUploading(data, file): Observable<any> {
      let formData = new FormData();
      formData.append("data", data);
      formData.append("file", file);    
      return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveDocumentsUploading', formData);
    }

    // Question Answer

   
  GetAllThought(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllThought', formData);
  }
  
  SaveThoughtDay(objModel,Content,FilePath): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    formData.append("Content", Content);
    formData.append("FilePath", FilePath);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveThoughtDay', formData);
  }
  RemoveThoughtDay(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/RemoveThoughtDay', formData);
  }
  ThoughtMarkActive(ID,IsActive): Observable<any> {
    let formData = new FormData();
    formData.append("ID", ID); 
    formData.append("IsActive", IsActive); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/ThoughtMarkActive', formData);
  }

   // Question Answer

   
   GetAllQuestionAnswer(objModel): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", objModel);   
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/GetAllQuestionAnswer', formData);
  }

  SaveQuestionAnswer(objModel,Content,FilePath): Observable<any> {   
      let formData = new FormData();
      formData.append("objModel", objModel);   
      formData.append("Content", Content);
      formData.append("FilePath", FilePath);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SaveQuestionAnswer', formData);
  }
  RemoveQusestionImage(objModel): Observable<any> {   
    let formData = new FormData();
    formData.append("objModel", objModel);   
    
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/RemoveQusestionImage', formData);
  }
  QuestionAnswerMarkActive(ID,IsActive): Observable<any> {
    let formData = new FormData();
    formData.append("ID", ID); 
    formData.append("IsActive", IsActive); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/QuestionAnswerMarkActive', formData);
  }

   // Exam Alert

   StudentUploadExamAlert(data: any): Observable<any> {
    let formData = new FormData();
    formData.append("StudentData", data);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/StudentUploadExamAlert', formData);
  }

  SendExamAlert(data, MessageType): Observable<any> {
    let formData = new FormData();
    formData.append("objList", data);  
    formData.append("MessageType", MessageType);  
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Communication/SendExamAlert', formData);
  }
}
